import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtokoppaltaxiservice() {



    const cardData = {




keyword: "Belgaum to Koppal Taxi Service",

headingDescription: "Belgaum Taxi Service offers comfortable and reliable Belgaum to Koppal taxi service for family travel, business trips, pilgrimage visits, historical tours, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Koppal, we provide safe transportation with experienced drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options based on your travel requirements. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth and convenient journey. Belgaum Taxi Service connects passengers between Belgaum and Koppal with affordable and comfortable cab solutions for tourists, families, professionals, and travelers exploring Karnataka.",

topPlaces: [
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site near Koppal, famous for ancient ruins, temples, royal structures, and historical monuments. It is one of the most popular tourist destinations in Karnataka."
  },
  {
    title: "Anegundi",
    description: "Anegundi is a historic village near Hampi known for ancient temples, heritage sites, and scenic landscapes, attracting history lovers and tourists."
  },
  {
    title: "Koppal Fort",
    description: "Koppal Fort is a historic landmark offering panoramic views and showcasing the rich cultural heritage of the region."
  },
  {
    title: "Anjanadri Hills",
    description: "Anjanadri Hills is a famous spiritual destination near Hampi, believed to be the birthplace of Lord Hanuman, attracting pilgrims and tourists."
  },
  {
    title: "Ittagi Mahadeva Temple",
    description: "Ittagi Mahadeva Temple is an ancient architectural marvel known for its beautiful carvings and historical importance."
  },
  {
    title: "Badami",
    description: "Badami is a heritage destination famous for rock-cut cave temples, sandstone cliffs, and Chalukyan architecture, making it a popular sightseeing location."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's major IT and business hub with technology parks, corporate offices, and commercial centers. Comfortable cabs provide convenient long-distance connectivity."
  },
  {
    title: "Goa",
    description: "Goa is a popular leisure destination known for beaches, resorts, churches, and sightseeing attractions. Private taxis are preferred for comfortable holiday travel."
  },
  {
    title: "Pune",
    description: "Pune is an important IT, education, and industrial city in Maharashtra. Travelers prefer private cabs for business trips and interstate journeys."
  },
  {
    title: "Mysore",
    description: "Mysore is a heritage city famous for Mysore Palace, Chamundi Hills, and cultural attractions, making it a preferred destination for family and tourist trips."
  }
],




"services": [
  {
    "name": "Belgaum to Koppal Taxi Service",
    "description": "Book Belgaum to Koppal Taxi Service for a safe, comfortable, and reliable journey with professional chauffeurs and well-maintained AC vehicles. Enjoy hassle-free outstation travel with Sedan, Ertiga, Innova Crysta, and SUV taxi options suitable for family trips, business travel, and personal journeys."
  },
  {
    "name": "Belgaum to Koppal Cab",
    "description": "Hire Belgaum to Koppal Cab for convenient intercity travel with experienced drivers, clean vehicles, and affordable fares. Get reliable cab services for one way trips, round trips, airport transfers, and customized travel requirements."
  },
  {
    "name": "Belgaum to Koppal Taxi",
    "description": "Reserve Belgaum to Koppal Taxi for comfortable long-distance travel with professional drivers and premium AC cars. Travel smoothly between Belgaum and Koppal with flexible booking options and affordable pricing."
  },
  {
    "name": "Belgaum to Koppal Cab Service",
    "description": "Choose Belgaum to Koppal Cab Service for dependable outstation transportation with doorstep pickup, transparent pricing, and 24x7 travel assistance. Our cab services provide comfortable rides for families, corporate travelers, and individual passengers."
  },
  {
    "name": "Belgaum to Koppal One Way Cab",
    "description": "Book Belgaum to Koppal One Way Cab for economical single-trip travel without return charges. Enjoy fixed fares, comfortable AC vehicles, experienced chauffeurs, and convenient pickup locations."
  },
  {
    "name": "Belgaum to Koppal One Way Taxi",
    "description": "Choose Belgaum to Koppal One Way Taxi for affordable point-to-point travel. Get reliable taxi services with professional drivers and multiple vehicle options according to your travel needs."
  },
  {
    "name": "Belgaum to Koppal Cab Booking",
    "description": "Complete Belgaum to Koppal Cab Booking with easy online reservations and quick confirmation. Select from Sedan, Ertiga, Innova Crysta, and SUV cabs for comfortable and safe travel."
  },
  {
    "name": "Belgaum to Koppal Taxi Booking",
    "description": "Book Belgaum to Koppal Taxi Booking services for a smooth travel experience with trained drivers, clean cars, and flexible journey plans. Suitable for family trips, business travel, and personal transportation."
  },
  {
    "name": "Belgaum to Koppal Car Rental",
    "description": "Choose Belgaum to Koppal Car Rental with driver for convenient outstation travel. Hire comfortable vehicles for sightseeing, business visits, family journeys, and long-distance transportation."
  },
  {
    "name": "Belgaum to Koppal Outstation Cab",
    "description": "Travel with Belgaum to Koppal Outstation Cab offering reliable intercity transportation, experienced chauffeurs, and well-maintained vehicles. Enjoy safe and comfortable journeys with one way and round trip options."
  },
  {
    "name": "Belgaum to Koppal Innova Crysta Cab",
    "description": "Book Belgaum to Koppal Innova Crysta Cab for premium and spacious travel. Enjoy luxury seating, large luggage space, and comfortable journeys ideal for families, groups, and corporate passengers."
  },
  {
    "name": "Belgaum to Koppal Ertiga Cab",
    "description": "Hire Belgaum to Koppal Ertiga Cab for affordable 6 to 7 seater travel. The spacious Ertiga cab is perfect for family trips, group travel, and outstation journeys with professional drivers."
  },
  {
    "name": "Belgaum to Koppal Sedan Cab",
    "description": "Book Belgaum to Koppal Sedan Cab for economical and comfortable transportation. Enjoy clean AC sedan cars with skilled chauffeurs suitable for business trips, personal travel, and small families."
  },
  {
    "name": "Belgaum to Koppal Round Trip Cab",
    "description": "Reserve Belgaum to Koppal Round Trip Cab for convenient return travel with affordable packages. Perfect for sightseeing, family visits, business travel, and planned journeys between both cities."
  },
  {
    "name": "Belgaum to Koppal Private Taxi",
    "description": "Choose Belgaum to Koppal Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and flexible schedules for your complete journey."
  },
  {
    "name": "Cheap Belgaum to Koppal Cab",
    "description": "Find Cheap Belgaum to Koppal Cab services with budget-friendly fares and quality vehicles. Travel safely with reliable drivers without compromising comfort and service standards."
  },
  {
    "name": "Best Belgaum to Koppal Taxi Service",
    "description": "Select the Best Belgaum to Koppal Taxi Service offering comfortable vehicles, experienced drivers, affordable rates, and dependable travel solutions for personal and business transportation."
  },
  {
    "name": "Online Belgaum to Koppal Cab Booking",
    "description": "Book Online Belgaum to Koppal Cab Booking services with easy reservations, instant confirmation, and multiple vehicle choices. Enjoy convenient travel planning from Belgaum to Koppal."
  },
  {
    "name": "Belgaum to Koppal Taxi Fare",
    "description": "Get affordable Belgaum to Koppal Taxi Fare with transparent pricing and flexible packages. Choose suitable cab options based on passengers, luggage, and travel requirements."
  },
  {
    "name": "Belgaum to Koppal Car Hire",
    "description": "Hire Belgaum to Koppal Car Hire services with professional drivers and comfortable vehicles. Ideal for outstation trips, family travel, corporate visits, and sightseeing journeys."
  },
  {
    "name": "Belgaum to Koppal Cab Price",
    "description": "Check Belgaum to Koppal Cab Price and choose affordable transportation options. Get reliable AC cabs with flexible one way, round trip, and customized travel packages."
  },
  {
    "name": "Belgaum to Koppal Family Cab",
    "description": "Book Belgaum to Koppal Family Cab for safe and comfortable family travel. Enjoy spacious vehicles, professional drivers, and convenient travel arrangements for vacations and personal trips."
  },
  {
    "name": "Belgaum to Koppal Corporate Taxi",
    "description": "Choose Belgaum to Koppal Corporate Taxi services for business travel and executive transportation. Get premium vehicles, punctual service, and professional chauffeurs for corporate requirements."
  },
  {
    "name": "Belgaum to Koppal Airport Transfer",
    "description": "Book Belgaum to Koppal Airport Transfer service for timely airport transportation with experienced drivers and comfortable vehicles. Enjoy smooth pickup and drop facilities with reliable cab options."
  },
  {
    "name": "Belgaum to Koppal Cab Fare",
    "description": "Get details about Belgaum to Koppal Cab Fare with affordable pricing and multiple vehicle categories. Select Sedan, Ertiga, Innova Crysta, or SUV cabs according to your travel needs."
  },
  {
    "name": "Belgaum to Koppal Taxi Near Me",
    "description": "Find Belgaum to Koppal Taxi Near Me for quick and reliable cab availability. Book comfortable taxis with professional drivers for safe outstation travel."
  },
  {
    "name": "Belgaum to Koppal Outstation Taxi",
    "description": "Hire Belgaum to Koppal Outstation Taxi for comfortable long-distance travel with clean AC vehicles and experienced chauffeurs. Enjoy reliable transportation for family, business, and personal journeys."
  },
  {
    "name": "Belgaum to Koppal Travel by Cab",
    "description": "Experience Belgaum to Koppal Travel by Cab with comfortable rides, professional drivers, and flexible travel options. Choose reliable taxi services for a smooth and convenient journey."
  }
],
"tableData": [
  ["Belgaum to Koppal Taxi Service", "Belgaum to Koppal Cab"],
  ["Belgaum to Koppal Taxi", "Belgaum to Koppal Cab Service"],
  ["Belgaum to Koppal One Way Cab", "Belgaum to Koppal One Way Taxi"],
  ["Belgaum to Koppal Cab Booking", "Belgaum to Koppal Taxi Booking"],
  ["Belgaum to Koppal Car Rental", "Belgaum to Koppal Outstation Cab"],
  ["Belgaum to Koppal Innova Crysta Cab", "Belgaum to Koppal Ertiga Cab"],
  ["Belgaum to Koppal Sedan Cab", "Belgaum to Koppal Round Trip Cab"],
  ["Belgaum to Koppal Private Taxi", "Cheap Belgaum to Koppal Cab"],
  ["Best Belgaum to Koppal Taxi Service", "Online Belgaum to Koppal Cab Booking"],
  ["Belgaum to Koppal Taxi Fare", "Belgaum to Koppal Car Hire"],
  ["Belgaum to Koppal Cab Price", "Belgaum to Koppal Family Cab"],
  ["Belgaum to Koppal Corporate Taxi", "Belgaum to Koppal Airport Transfer"],
  ["Belgaum to Koppal Cab Fare", "Belgaum to Koppal Taxi Near Me"],
  ["Belgaum to Koppal Outstation Taxi", "Belgaum to Koppal Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Koppal Taxi Service",
    WhyChoosedescription: "Travel from Belgaum to Koppal with a dependable taxi solution featuring comfortable vehicles, skilled chauffeurs, and convenient travel arrangements for personal and professional journeys."
  },
  {
    WhyChooseheading: "Direct Route Travel Convenience",
    WhyChoosedescription: "Enjoy point-to-point transportation between Belgaum and Koppal with flexible pickup locations and smooth drop services at your destination."
  },
  {
    WhyChooseheading: "Cab Options Matching Your Needs",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, and SUV cars depending on your passenger count, luggage space, and comfort preferences."
  },
  {
    WhyChooseheading: "Ideal for Family & Business Trips",
    WhyChoosedescription: "Our Belgaum to Koppal taxis are suitable for family visits, work-related travel, sightseeing plans, and personal transportation needs."
  },
  {
    WhyChooseheading: "Experienced Drivers on Long Routes",
    WhyChoosedescription: "Professional drivers ensure smooth navigation, timely travel, and a comfortable ride with proper route knowledge."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Plans",
    WhyChoosedescription: "Choose a one-way drop taxi or plan a return journey based on your schedule with convenient travel options."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Outstation Travel",
    WhyChoosedescription: "Well-maintained cars with clean interiors provide a relaxed experience for the complete Belgaum to Koppal journey."
  },
  {
    WhyChooseheading: "Simple Booking Experience",
    WhyChoosedescription: "Get assistance for vehicle selection, fare details, and trip planning to arrange your Belgaum to Koppal taxi easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Koppal Taxi Service?",
    answer: "Yes, we provide Belgaum to Koppal taxi services with comfortable vehicles and experienced drivers for outstation travel."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Koppal?",
    answer: "Yes, one-way cab service is available for passengers who need direct travel from Belgaum to Koppal."
  },
  {
    question: "Which cars are available for Belgaum to Koppal travel?",
    answer: "You can select Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your travel requirements."
  },
  {
    question: "Is Belgaum to Koppal taxi suitable for family travel?",
    answer: "Yes, spacious vehicles are available for families with comfortable seating and sufficient luggage capacity."
  },
  {
    question: "Can I hire a round-trip cab from Belgaum to Koppal?",
    answer: "Yes, return journey taxi options are available with flexible timings and customized travel plans."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop services are available from Belgaum Airport, Railway Station, hotels, and other preferred locations."
  },
  {
    question: "Is this taxi service available for business travel?",
    answer: "Yes, the service is suitable for corporate visits, meetings, official work trips, and professional transportation."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll charges, parking fees, and additional costs depend on the selected package and are communicated during booking."
  },
  {
    question: "Can I book a private cab from Belgaum to Koppal?",
    answer: "Yes, private taxi options are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "How can I book a Belgaum to Koppal Taxi?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harish Desai",
    feedback: "The Belgaum to Koppal taxi service provided a comfortable journey with a professional driver and well-maintained vehicle. The travel experience was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "We had a pleasant trip from Belgaum to Koppal. The cab was clean, the driver was cooperative, and the service was arranged perfectly.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Koppal Taxi Service",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-koppal-taxi-service.webp",
  "description":
    "Book Belgaum to Koppal Taxi Service with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Koppal with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-koppal-taxi-service"
  }
};





    return (
        <div>




<Helmet>
  <title>Belgaum to Koppal Taxi Service | One Way Cab | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Koppal Taxi Service with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Koppal with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Koppal Taxi Service, Belgaum to Koppal Cab, Belgaum to Koppal Taxi, Belgaum to Koppal Cab Service, Belgaum to Koppal One Way Cab, Belgaum to Koppal One Way Taxi, Belgaum to Koppal Cab Booking, Belgaum to Koppal Car Rental, Belgaum to Koppal Outstation Cab, Belgaum to Koppal Taxi Fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtokoppaltaxiservice;